<script setup lang="ts"></script>

<template>
  <h2>Unverified</h2>
  <p>Your account has not been verified.</p>
  <p>
    Please contact an administrator to get your account verified and begin using
    this application.
  </p>
</template>
